import Title from "../../../components/title/Title";

import "./Student.css";
import axios from "axios";

import { Modal } from "antd";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const Student = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [feedbacks, setFeedbacks] = useState(null);
  const [data, setData] = useState({
    date: "",
    lessonInfo: "",
    goals: "",
    nextLesson: "",
    comment: "",
  });
  const { id } = useParams();
  useEffect(() => {
    console.log("useEffect");
    getFeedback();
  }, []);

  const getFeedback = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/actions/feedback/${id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });

      setTimeout(() => {
        setLoading(false);
        if (response.data.length > 0) {
          setFeedbacks(response.data);
        }
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  const addFeedback = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`/api/actions/feedback/${id}`, data, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      console.log(response.status);
      console.log(response.data);

      setLoading(false);
      if (response.status === 200) {
        setData({
          date: "",
          lessonInfo: "",
          goals: "",
          nextLesson: "",
          comment: "",
        });
        getFeedback();
        hideModal();
        Swal.fire({
          text: "דיווח נשלח בהצלחה",
          icon: "success",
          confirmButtonText: "סגירה",
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "שגיאה",
        text: "נסו שנית מאוחר יותר",
        icon: "error",
        confirmButtonText: "סגירה",
      });
    }
  };

  const loadOptions = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await axios.get(`/api/actions/feedback/options`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      // console.log(response.status);
      // console.log(response.data);

      setLoading(false);
      if (response.status === 200) {
        const inputOptions = {};
        response.data.forEach((option, index) => {
          inputOptions[option.ReasonsDesc] = option.ReasonsDesc;
        });
        const { value } = await Swal.fire({
          title: "טעינת טקסט",
          input: "select",
          inputOptions,
          inputPlaceholder: "לחץ/י לצפייה באפשרויות",
          showCancelButton: true,
          // inputValidator: (value) => {
          //   return new Promise((resolve) => {
          //     if (value === 'oranges') {
          //       resolve()
          //     } else {
          //       resolve('You need to select oranges :)')
          //     }
          //   })
          // }
        });
        if (value) {
          setData({ ...data, lessonInfo: `${data.lessonInfo}.\n${value}` });
        }
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "שגיאה",
        text: "נסו שנית מאוחר יותר",
        icon: "error",
        confirmButtonText: "סגירה",
      });
    }
  };

  const onInuptChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const onTextareaChange = (e) => {
    console.log(e.target.value);
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <div id="student">
      <Title
        onAddButtonClick={showModal}
        text={sessionStorage.getItem("studentName")}
        displayBackButton={true}
      />
      {feedbacks && (
        <div id="contant">
          {/* <h3>דיווח אחרון</h3> */}
          {feedbacks.map((feedback, index) => {
            return <p key={index}>{feedback.Content}</p>;
          })}
        </div>
      )}

      <Modal
        onOk={hideModal}
        footer={[]}
        onCancel={hideModal}
        visible={isModalVisible}
        centered
      >
        <h3>דיווח חדש</h3>
        <form onSubmit={addFeedback}>
          <label for="date">תאריך:</label>
          <input
            onChange={onInuptChange}
            name="date"
            value={data.date}
            type="date"
            id="date"
          />
          <label for="lessonInfo">מהלך השיעור:</label>
          <button onClick={loadOptions}>טעינת אפשרויות</button>
          <textarea
            value={data.lessonInfo}
            onChange={onTextareaChange}
            id="lessonInfo"
            name="lessonInfo"
            rows="6"
          />
          <label for="goals">מטרות:</label>
          <textarea
            value={data.goals}
            onChange={onTextareaChange}
            id="goals"
            name="goals"
            rows="6"
            maxLength="2000"
          />

          <label for="nextLesson">שיעור הבא:</label>
          <textarea
            value={data.nextLesson}
            onChange={onTextareaChange}
            id="nextLesson"
            name="nextLesson"
            rows="6"
          />
          <label for="comment">הערות:</label>
          <textarea
            value={data.comment}
            onChange={onTextareaChange}
            id="comment"
            name="comment"
            rows="6"
          />

          <div id="buttonLocation">
            <input type="submit" value="שליחת דיווח" />
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default Student;
